import PropTypes from 'prop-types';
import React from 'react';
import BaseComponent from 'apps/new-web/views/component';
import { getImageUrl } from 'apps/new-web/asset-mgmt/get-asset-url';

export default class Image extends BaseComponent {
  static get propTypes() {
    return {
      src: PropTypes.string.isRequired,
      alt: PropTypes.string
    };
  }

  render() {
    const { src, alt, ...otherProps } = this.props;
    return <img src={ getImageUrl(src) } alt={ alt } { ...otherProps } />;
  }
}